import { useMutation, useQueryClient } from "@tanstack/react-query";
import toast from "react-hot-toast";
import { updateWhyChooseUsItem } from "../../api/apiWhyChooseUs";
import parseError from "../../utils/parseError";
import { useNavigate } from "react-router-dom";

export function useUpdateWhyChooseUsItem() {
    const queryClient = useQueryClient();
    const navigate = useNavigate();

    const { mutate: updateItemMutate, isPending } = useMutation({
        mutationFn: ({ id, data }) => updateWhyChooseUsItem(id, data),
        onSuccess: (response) => {
            toast.success(response.message || "Updated successfully");
            queryClient.invalidateQueries({ queryKey: ["why-choose-us-items"] });
            queryClient.invalidateQueries({ queryKey: ["why-choose-us-item"] });
            navigate("/why-choose-us");
        },
        onError: (error) => {
            const message = parseError(error);
            toast.error(message || "Failed to update item");
        },
    });

    return { updateItemMutate, isPending };
}
